import { useAuthContext } from '../auth/Auth';
import { DockBar } from './DockBar';
import { DockOverlay } from './DockOverlay';

export const Dock = () => {
    const { isAuthenticated } = useAuthContext();
    if (!isAuthenticated) return null;
    return (
        <div className="fixed right-1.5 bottom-0 z-[10] flex max-w-[100vw] flex-col items-end justify-end px-3">
            <DockOverlay />
            <DockBar />
        </div>
    );
};
